import { useState } from 'react';

interface IPollRadio {
  option: string;
  handleSingleChoiceChange: any;
  name: string;
  questionNum: number;
  responses: any;
}

const PollRadio = ({ option, handleSingleChoiceChange, name, questionNum, responses }: IPollRadio) => {
  return (
    <label
      className={`w-full cursor-pointer flex gap-2 items-center ${
        responses[questionNum] === option
          ? 'bg-red-main text-white'
          : 'bg-black bg-opacity-5 hover:bg-opacity-10 text-black'
      } px-4 py-3 rounded-lg text-white`}
    >
      <input
        type="radio"
        id={option}
        value={option}
        name={name}
        checked={responses[questionNum] === option}
        onChange={() => {
          handleSingleChoiceChange(questionNum, option);
        }}
        className="mr-2 focus:ring-red-main bg-red-main focus:bg-red-main hidden"
      />
      <div className="flex relative">
        <svg
          className={`w-6 h-6 ${responses[questionNum] === option ? 'fill-current' : 'fill-red-main'}`}
          focusable="false"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path>
        </svg>
        <svg
          className={`w-6 h-6 absolute left-0 ${responses[questionNum] === option ? 'fill-current' : 'hidden'} `}
          focusable="false"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"></path>
        </svg>
      </div>
      {option}
    </label>
  );
};

export default PollRadio;
